import { Injectable } from '@angular/core';
import { EBasicField } from 'src/app/project/shared/enums/basic-fields-enums';
import { ECustomFieldType } from '../../custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from '../../custom-fields/custom-fields.store';
import { TSearchFilterDTO } from '../../filters-advanced/models/advanced-filter.model';
import { QuickFilterService } from '../../filters/filters-api/search/quick-filter-service';
import { EQuickFilterTranslatedKey } from '../../filters/filters-api/search/quick-filter.consts';
import { ETimelineGroup } from '../../preferences/preferences.model';
import { GET_PREFERENCES } from '../../preferences/preferences.store';
import { ESortOrder } from '../../site/site-table/sort-order-enum';
import {
  EPointSearchOperator,
  TSearchAdvancedFilterOperator,
  TSearchFilterSubgroup,
  TSearchResponseDTO,
} from './point-search.consts';

@Injectable({
  providedIn: 'root',
})
export class TimelinePointSearchService {
  constructor(private quickFilterService: QuickFilterService) {}

  getTimelineQuery(): TSearchResponseDTO {
    return {
      pagination: {
        cursor: null,
        pageSize: 100000,
      },
      data: this.getTimelineFields(),
      filter: this.addTimelineFilters(this.quickFilterService.getFiltersTransformed()),
      sort: this.addTimelineSort(),
    };
  }

  private getTimelineFields(): string[] {
    const customFields = GET_CUSTOM_FIELDS();
    const timelineFields: string[] = [];

    Object.values(customFields)
      .filter((field) => field.type === ECustomFieldType.TIMELINE)
      .forEach((field) => {
        timelineFields.push(field.id);
      });
    return [
      EBasicField.PRIORITY.toLowerCase(),
      EQuickFilterTranslatedKey.ID,
      EBasicField.STATUS.toLowerCase(),
      EBasicField.TITLE.toLowerCase(),
      EBasicField.FLAGGED.toLowerCase(),
      EQuickFilterTranslatedKey.WORKSPACE_REF_ID,
      ...timelineFields,
    ];
  }

  private addTimelineFilters(filters: {
    groupOperator: TSearchAdvancedFilterOperator;
    groups: TSearchFilterSubgroup[];
    criteria: TSearchFilterDTO[];
  }): {
    groupOperator: TSearchAdvancedFilterOperator;
    groups: TSearchFilterSubgroup[];
    criteria: TSearchFilterDTO[];
  } {
    const customFields = GET_CUSTOM_FIELDS();
    const criteria: TSearchFilterDTO[] = [];

    Object.values(customFields)
      .filter((field) => field.type === ECustomFieldType.TIMELINE)
      .forEach((field) => {
        criteria.push({
          key: field.id,
          operator: EPointSearchOperator.GREATER_THAN,
          values: ['0'],
          timelinePosition: 'START',
        });
      });

    const timelineGroups: TSearchFilterSubgroup[] =
      criteria.length > 0 ? [{ criteriaOperator: 'OR', criteria }] : [];

    if (!filters) {
      return {
        groupOperator: 'AND',
        groups: timelineGroups,
        criteria: [],
      };
    }

    return {
      groupOperator: filters.groupOperator,
      groups: [...filters.groups, ...timelineGroups],
      criteria: filters.criteria,
    };
  }

  private addTimelineSort(): TSearchResponseDTO['sort'] {
    const preferences = GET_PREFERENCES();
    const timelineGroup = preferences.timeline?.group ? preferences.timeline.group : null;

    if (timelineGroup) {
      switch (timelineGroup) {
        case ETimelineGroup.ACCOUNT:
          return [
            {
              keys: ['accountName'],
              direction: ESortOrder.DESC,
            },
          ];
        case ETimelineGroup.SITE:
          return [{ keys: ['siteName'], direction: ESortOrder.DESC }];
      }
    }

    return [
      {
        keys: ['header.createdEpochMillis'],
        direction: ESortOrder.DESC,
      },
    ];
  }
}
